import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FundNext.css'
import { Link, LinkIcon } from '../'
import format from '../../helpers/format'
import config from '../../config'

@CSSModules(Styles,{allowMultiple:true})
export default class FundNext extends Component {
  static propTypes = {
    prev: PropTypes.string,
    prevLabel: PropTypes.string,
    next: PropTypes.string,
    nextLabel: PropTypes.string,
    ticker: PropTypes.string,
    name: PropTypes.string.isRequired,
    investmentVehicleId: PropTypes.string.isRequired,
    fundId: PropTypes.string.isRequired,
  }
  constructor(props){
    super(props);
  }

  render() {
    const ticker = this.props.ticker ? this.props.ticker : 'N'
    const name = format.sanitize(this.props.name)
    const prevUrl = config.routes.fund+'/'+name+'/'+ticker+'/'+this.props.prev+'/'+this.props.fundId+'/'+this.props.investmentVehicleId
    const nextUrl = config.routes.fund+'/'+name+'/'+ticker+'/'+this.props.next+'/'+this.props.fundId+'/'+this.props.investmentVehicleId

    return (
      <div styleName='next-wrap'>
        <div styleName='next-container'>
          <div styleName='next-container-inner'>
            <div styleName='next'>

              {
                (this.props.prev)?(
                  <div styleName='next-left'>
                    <Link
                      to={prevUrl}
                      title={this.props.prevLabel}>
                      <span styleName='label-left'><i className='fa fa-angle-double-left'/> {(this.props.prevLabel)}</span>
                    </Link>
                  </div>
                ):(<div styleName='next-left'/>)
              }

              <span styleName='label'>{(this.props.ticker)}</span>

              {
                (this.props.next)?(
                  <div styleName='next-right'>
                    <Link
                      to={nextUrl}
                      title={this.props.nextLabel}>
                      <span styleName='label-right'>{(this.props.nextLabel)}<LinkIcon /></span>
                    </Link>
                  </div>
                ):(<div styleName='next-right'/>)
              }

            </div>
          </div>
        </div>
      </div>
    )
  }
}

